<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BFormInput
            id="filterSearch"
            v-model="tableTeams.filter.search"
            placeholder="search here"
            autocomplete="off"
            debounce="1000"
            type="text"
          />
        </BFormGroup>
      </BCol>
      <BCol
        cols="12"
      >
        <BButton
          size="sm"
          variant="primary"
          @click.prevent="createTeam"
        >
          Create Team
        </BButton>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableTeams"
      :provider="tableProvider"
      :fields="tableTeams.fields"
      :filter="tableTeams.filter"
      :filter-on="tableTeams.filterOn"
      :sort-by="tableTeams.sortBy"
      :sort-desc="tableTeams.sortDesc"
      :sort-direction="tableTeams.sortDirection"
      :total-rows="tableTeams.totalRows"
      :current-page="tableTeams.currentPage"
      :per-page="tableTeams.perPage"
      :stacked="tableTeams.stacked"
      :busy="tableTeams.busy"
    >
      <template #cell(action)="{ item }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
          <BButton
            size="sm"
            variant="primary"
            :disabled="tableTeams.busy"
            @click.prevent="editTeam(item)"
          >
            Edit
          </BButton>
        </div>
      </template>
    </CustomTable>

    <BModal
      ref="modalTeam"
      centered
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      aria-hidden="false"
      role="dialog"
      :title="MTeamTitle"
    >
      <ValidationObserver
        ref="formTeam"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="team code"
                vid="team_code"
                rules="required|max:150"
              >
                <BFormGroup
                  label="Team Code"
                  label-for="fTeamCode"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fTeamCode"
                    v-model="formTeam.team_code"
                    type="text"
                    maxlength="150"
                    autocomplete="off"
                    placeholder="enter team code here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="team name"
                vid="team_name"
                rules="required|max:150"
              >
                <BFormGroup
                  label="Team Name"
                  label-for="fTeamName"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fTeamName"
                    v-model="formTeam.team_name"
                    type="text"
                    maxlength="150"
                    autocomplete="off"
                    placeholder="enter team name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>

            <BCol
              v-if="state.editing"
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="fActive"
                  v-model="formTeam.active"
                  switch
                  value="1"
                  name="active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>
        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          :disabled="state.busy"
          @click.prevent="validateTeam"
        >
          {{ state.editing ? 'Update' : 'Create' }} Team
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

import { SAdminTeam } from '@/services/admin'

export default {
  name: 'VAdminLocationsTeams',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth',
    'admin'
  ],

  metaInfo: () => ({
    title: 'Teams'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      formTeam: {
        id: '',
        team_code: '',
        team_name: '',
        active: 1
      },
      tableTeams: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 6, key: 'action', class: 'text-center w-md-125px' },
          { mobile: 1, key: 'team_code', class: 'min-w-150px' },
          { mobile: 2, key: 'team_name', class: 'min-w-175px' },
          { mobile: 4, key: 'active', class: 'text-md-center w-md-75px', formatter: this.yesOrNo },
          { mobile: 5, key: 'updated_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    MTeamTitle () {
      return this.state.editing ? 'Edit Team' : 'Create Team'
    }
  },

  methods: {

    vTabTeamDetails () {
      if (this.$refs.formTeam) {
        const formTeamErrors = this.$refs.formTeam.errors
        return Object.keys(formTeamErrors).some(
          errorKey => formTeamErrors[errorKey]?.length > 0
        )
      }

      return false
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableTeams.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search
      }

      return await SAdminTeam.get(payload).then(
        ({ data }) => {
          this.tableTeams.totalRows = data.total_rows
          return data.items
        }
      ).catch(() => {
        this.tableTeams.totalRows = 0
        return []
      }).finally(() => {
        this.tableTeams.busy = false
      })
    },

    createTeam () {
      this.state.editing = false

      this.formTeam = Object.assign(this.formTeam, {
        id: '',
        team_code: '',
        team_name: '',
        active: 1
      })

      this.$refs.modalTeam.show()
    },

    editTeam (team) {
      this.state.editing = true

      this.formTeam = Object.assign(this.formTeam, {
        id: team.id,
        team_code: team.team_code,
        team_name: team.team_name,
        active: team.active
      })

      this.$refs.modalTeam.show()
    },

    updateRegions (regions) {
      this.formTeam.regions = regions
    },

    async validateTeam () {
      await this.$refs.formTeam.validate().then(
        async validTeam => {
          if (!validTeam) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: this.state.editing ? '<h6>Update this Team?</h6>' : '<h6>Create this Team?</h6>',
            confirmButtonText: this.state.editing ? 'Update' : 'Create',
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return this.state.editing ? this.putTeam() : this.postTeam()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  this.$refs.formTeam.setErrors(message.errors)
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    async postTeam () {
      return await SAdminTeam.post(this.formTeam).then(
        ({ data: { message } }) => {
          this.swalSuccess(message).then(() => {
            this.$refs.modalTeam.hide()
            this.$refs.tableTeams.refetch()
          })
        }
      )
    },

    async putTeam () {
      return await SAdminTeam.put(this.formTeam).then(
        ({ data: { message, team } }) => {
          this.swalSuccess(message).then(() => {
            this.$refs.modalTeam.hide()
            this.$refs.tableTeams.updateRow({
              id: team.id,
              team_code: team.team_code,
              team_name: team.team_name,
              active: team.active,
              updated_at: team.updated_at
            })
          })
        }
      )
    }
  }
}
</script>
